import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import Loader from "../../loader";

const ContentContainer = (props) => {
  const { t } = useTranslation();
  const _items = props.reducer
    ? props.reducer.map((data, i) => props.content(data, i))
    : [];
  const [items, setItems] = useState(_items);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  async function loadFunc() {
    const params = {
      pageCount: pageCount,
      ...props.params,
    };
    setIsLoading(true);
    setHasError(false);

    try {
      if (props.reducer) {
        await props.dispatchGet(() => props.get(params));
      } else {
        const r = await props.get(params);
        const mappedR = r.map((data, i) => props.content(data, i));
        if (params.pageCount === 0) {
          setItems(mappedR);
        } else {
          setItems(items.concat(mappedR));
        }
      }
      setHasLoaded(true);
    } catch (error) {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (props.loadOnMount !== false && items.length < 1 && !isLoading) {
      loadFunc();
    }
  }, []);

  useEffect(() => {
    if (items.length > 0 && pageCount > 0) {
      loadFunc();
    }
  }, [pageCount]);

  useEffect(() => {
    if (!isLoading && props.params) {
      const reloadTimer = setTimeout(() => {
        setPageCount(0);
        loadFunc();
      }, 300);
      return () => clearTimeout(reloadTimer);
    }
  }, [props.params]);

  useEffect(() => {
    if (props.reducer) {
      setItems(props.reducer.map((data, i) => props.content(data, i)));
      setIsLoading(false);
    }
  }, [props.reducer]);

  function loadMore() {
    if (!isLoading) {
      setPageCount(pageCount + 1);
    }
  }

  const isBusy = isLoading || props.loading;
  const showError = hasError || props.error;
  const isLoaded = props.loaded === undefined ? hasLoaded : props.loaded;

  const button =
    items.length > 9 ? (
      <div className="d-flex justify-content-center my-4">
        <Button
          onClick={() => {
            loadMore();
          }}
          color="primary"
          outline
          style={{ display: !isBusy ? "inline-block" : "none" }}
        >
          {t("load-more")}
        </Button>
      </div>
    ) : null;

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          
        }}
      >
        {items}
      </div>
      {button}
      {isBusy && <Loader height={80} label={t("loading-results")} />}
      {showError && (
        <div className="alert alert-danger text-center" role="alert">
          {t("load-error")}
          <Button
            className="ms-2"
            color="danger"
            outline
            onClick={() => loadFunc()}
            disabled={isBusy}
          >
            {t("try-again")}
          </Button>
        </div>
      )}
      {!isBusy && !showError && isLoaded && items.length === 0 && (
        <div className="alert alert-info text-center" role="status">
          {t("no-items")}
        </div>
      )}
    </div>
  );
};

export default ContentContainer;